// @flow
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import style from './LowestPrice.scss';

import type { Forecast } from '../../../../QuoteStep/api';

type Props = {
  +forecast?: Forecast;
  +loadingForecast: boolean;
};

export const LowestPriceEmpty = () => {
  return (
    <div className={style.forecastEmpty}/>
  );
};

export default class LowestPrice extends Component<Props> {
  render() {
    const { forecast, loadingForecast } = this.props;
    const f = forecast ? forecast['CLASSIC'] : [];
    const lowerPrice = forecast && f.length && forecast[f.length - 1].total || '- - -';
    const forecastStyle = (!loadingForecast && f.length > 0)
      ? style.hasForecast : style.noForecast;
    return (
      <section className={classNames(style.forecast, forecastStyle)}>
        <FormattedMessage id="newOrder.products.form.lowestPrice">{
          txt => <p>{txt}:</p>
        }</FormattedMessage>
        <p>{(!loadingForecast && !!forecast) ? '$' : ''} {lowerPrice}</p>
      </section>
    );
  }
}

LowestPrice.propTypes = {
  forecast: PropTypes.array,
  loadingForecast: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/ProductForm/LowestPrice/LowestPrice.jsx